import * as React from 'react';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Listing from '../Listing';
import styles from './style.module.css';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

export default class Book extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    return (
      <div>
        <form>
          <Typography variant="display3" gutterBottom>
            BOOK SLOT
          </Typography>
          <InputLabel htmlFor="resource-center">
            Choose Resource Center
          </InputLabel>
          &nbsp;&nbsp;
          <Select
            inputProps={{
              name: 'resource-center',
              id: 'resource-center',
            }}
          />
          <br />
          <br />
          <InputLabel htmlFor="service-provider">
            Choose Service Provider
          </InputLabel>
          &nbsp;&nbsp;
          <Select
            inputProps={{
              name: 'service-provider',
              id: 'service-provider',
            }}
          />
          <br />
          <br />
          <Typography
            className={styles.bookDate}
            variant="headline"
            gutterBottom
          >
            TODAY 21 Baisakh 2075&nbsp;
          </Typography>
          <ArrowRightIcon className={styles.arrowRight} />
        </form>
        <div className="">
          <AppBar position="static">
            <Tabs value={this.state.value} onChange={this.handleChange}>
              <Tab label="Morning" />
              <Tab label="Day" />
              <Tab label="Evening" href="#basic-tabs" />
            </Tabs>
          </AppBar>
          {this.state.value === 0 && <TabContainer>Morning</TabContainer>}
          {this.state.value === 1 && <TabContainer>Day</TabContainer>}
          {this.state.value === 2 && <TabContainer>Evening</TabContainer>}
        </div>
        <Listing />
      </div>
    );
  }
}
